import { render } from "./StockPortfolio.vue?vue&type=template&id=04453b5b&scoped=true"
import script from "./StockPortfolio.vue?vue&type=script&lang=js"
export * from "./StockPortfolio.vue?vue&type=script&lang=js"

import "./StockPortfolio.vue?vue&type=style&index=0&id=04453b5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04453b5b"]])

export default __exports__